import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  MANAGE_SUBS_RESET_SUBSTITUTIONS_DATA,
} from './constants';

export function resetSubstitutionsData() {
  return {
    type: MANAGE_SUBS_RESET_SUBSTITUTIONS_DATA,
  };
}

export function useResetSubstitutionsData() {
  const dispatch = useDispatch();
  const substitutionsData = useSelector(state => state.manageSubs.substitutionsData);
  const boundAction = useCallback((...params) => dispatch(resetSubstitutionsData()), [dispatch]);
  return { substitutionsData, resetSubstitutionsData: boundAction };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_RESET_SUBSTITUTIONS_DATA:
      return {
        ...state,
        substitutionsData: null,
      };

    default:
      return state;
  }
}
